import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export type CheckUserType = { isAllowedToContinue: boolean; URL: string | undefined };
export enum Status {
  complete = 1,
  overQuota,
  terminate,
  security
}
@Injectable({
  providedIn: 'root'
})
export class RedirectionService {
  constructor(private http: HttpClient) {}
  getQuota(): Observable<CheckUserType> {
    return this.http.get<CheckUserType>(`${environment.backendURL}/redirection/quota`);
  }

  checkUser(): Observable<CheckUserType> {
    return this.http.get<CheckUserType>(`${environment.backendURL}/redirection/checkUser`);
  }

  createUser(): Observable<void> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    // Assuming the sent QueryParameters are used to create the user.
    return this.http.post<void>(`${environment.backendURL}/redirection/create`, {}, httpOptions);
  }

  setStatus(status: Status): Observable<void> {
    const params = new HttpParams().set('RS', status);
    return this.http.post<void>(`${environment.backendURL}/redirection/ending`, {}, { params: params });
  }
}
